import { render, staticRenderFns } from "./ReserCard.vue?vue&type=template&id=779fab0c&scoped=true"
import script from "./ReserCard.vue?vue&type=script&lang=js"
export * from "./ReserCard.vue?vue&type=script&lang=js"
import style0 from "./ReserCard.vue?vue&type=style&index=0&id=779fab0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779fab0c",
  null
  
)

export default component.exports